import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';

class SidebarAdmin extends Component {

  state = {
    username:''
  };

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(Object.keys(this.state).length === 0) {
      this.setState({[menuState] : true});
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({[i]: false});
      });
      this.setState({[menuState] : true});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({[i]: false});
    });

    const dropdownPaths = [
      {path:'/apps', state: 'appsMenuOpen'},
      {path:'/basic-ui', state: 'basicUiMenuOpen'},
      {path:'/advanced-ui', state: 'advancedUiMenuOpen'},
      {path:'/form-elements', state: 'formElementsMenuOpen'},
      {path:'/tables', state: 'tablesMenuOpen'},
      {path:'/maps', state: 'mapsMenuOpen'},
      {path:'/icons', state: 'iconsMenuOpen'},
      {path:'/charts', state: 'chartsMenuOpen'},
      {path:'/user-pages', state: 'userPagesMenuOpen'},
      {path:'/error-pages', state: 'errorPagesMenuOpen'},
      {path:'/general-pages', state: 'generalPagesMenuOpen'},
      {path:'/ecommerce', state: 'ecommercePagesMenuOpen'},
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({[obj.state] : true})
      }
    }));
 
  }

  render () {
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li className="nav-item nav-profile">
            <a href="!#" className="nav-link" onClick={evt =>evt.preventDefault()}>
            
              <div className="nav-profile-text">
                <span className="font-weight-bold mb-2"><Trans>{this.state.username}</Trans></span>
                <span className="text-secondary text-small"><Trans>Adminstrator</Trans></span>
              </div>
              <i className="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
            </a>
          </li>
          <li className={ this.isPathActive('/dashboard') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/dashboard">
              <span className="menu-title"><Trans>Dashboard</Trans></span>
              <i className="mdi mdi-home menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/lookups') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/lookups">
              <span className="menu-title"><Trans>Master Lookups</Trans></span>
              <i className="mdi mdi-table-large menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/recruiters') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/recruiters">
              <span className="menu-title"><Trans>Recruiter Master</Trans></span>
              <i className="mdi mdi-table-large menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/userlist') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/userlist">
              <span className="menu-title"><Trans>User ID Level Changes</Trans></span>
              <i className="mdi mdi-table-large menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/jdlist') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/jdlist">
              <span className="menu-title"><Trans>List JD's</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/jdaddition') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/jdaddition">
              <span className="menu-title"><Trans>New JD Addition</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/jdmaster') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/jdmaster">
              <span className="menu-title"><Trans>JD Master</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/client') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/client">
              <span className="menu-title"><Trans>Client Master</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/adminofferlist') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/adminofferlist">
              <span className="menu-title"><Trans>Offers</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/invoice') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/invoice">
              <span className="menu-title"><Trans>Invoice</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/allcandidates') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/allcandidates">
              <span className="menu-title"><Trans>List of Candidates</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>
          <li className={ this.isPathActive('/templatelist') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/templatelist">
              <span className="menu-title"><Trans>Email Templates</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>

          <li className={ this.isPathActive('/contentedit') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/contentedit">
              <span className="menu-title"><Trans>Content Edit</Trans></span>
              <i className="mdi mdi-chart-bar menu-icon"></i>
            </Link>
          </li>

         
        
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    this.setState({username: sessionStorage.getItem('displayName')});
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}

export default withRouter(SidebarAdmin);